import React, { useState } from "react";
import sha256 from "js-sha256";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  calculateAge,
  getCountryLabel,
  getGender,
  getSign,
  getStateLabel,
  reportTypes,
} from "../services/functions";

export default function ReportGenSection({ show, onHide, onClick, title }) {
  const navigate = useNavigate();
  const currentCustomer = useSelector((state) => state.currentCustomer);
  const hash = sha256(currentCustomer.user.email);
  const accessToken = localStorage.getItem("accessToken");
  const addWowReportUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/wowreports/add?hash=${hash}`;

  const [reportInput, setReportInput] = useState({ reportType: 0 });
  const [buttonText, setButtonText] = useState("Generate");
  const [showSpinner, setShowSpinner] = useState("visually-hidden");
  const [reportSent, setReportSent] = useState(false);

  const reportTypesList = reportTypes.map((item, i) => (
    <option key={i} value={item.value}>
      {item.label}
    </option>
  ));

  const handleErrorResponse = (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      navigate("/login");
    } else {
      console.error("Error:", error);
    }
  };

  const postWowReport = async (url, postData) => {
    try {
      const result = await axios.post(url, postData, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (result.data.status === "success") {
        setShowSpinner("visually-hidden");
        setButtonText("Generate");
        setReportSent(true);
      }
    } catch (error) {
      handleErrorResponse(error);
    }
  };

  const sendRequest = async (url) => {
    try {
      const result = await axios.get(url);

      if (result.data === "Success - Report Generated") {
        setShowSpinner("visually-hidden");
        setButtonText("Generate");
        setReportSent(true);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const sendRequestWow = async (url, reportType) => {
    try {
      await fetch(url, { method: "GET", mode: "no-cors" });

      const postData = {
        email: currentCustomer.user.email,
        status: 1,
        isAdmin: 1,
        type: reportType,
      };

      postWowReport(addWowReportUrl, postData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleRequest = () => {
    const {
      email,
      firstName,
      lastName,
      gender: rawGender,
      birthDay,
      birthCountry,
      birthCity,
      birthPlaceId,
      birthTime,
    } = currentCustomer.user;

    const gender = parseGender(rawGender);
    const customerAge = calculateCustomerAge(birthDay);

    if (!isValidBirthDay(birthDay)) {
      alert("Please update the Date of Birth from customer's section.");
      return;
    }

    if (!isValidReportType(reportInput.reportType)) {
      alert("Please Select Report Type");
      return;
    }

    if (isBirthPlaceIdRequired(reportInput.reportType) && birthPlaceId <= 0) {
      alert(
        "Please choose the city from the dropdown list in the customer's section."
      );
      return;
    }

    const postParams = createPostParams({
      firstName,
      lastName,  
      gender,
      email,
      birthDay,
      birthCountry,
      birthCity,
      birthPlaceId,
      customerAge,
      birthTime,
    });

    const reportData = getReportData(reportInput.reportType);
    if (!reportData) {
      alert("Invalid Report Type");
      return;
    }

    const reportUrl = createReportUrl(reportData, postParams);

    setButtonText("Submitting request...");
    setShowSpinner("");

    sendRequestBasedOnType(reportUrl, reportData.type);
  };

  const parseGender = (rawGender) => {
    const gender = rawGender?.toLowerCase();
    if (gender === "female" || gender === "f") return 0;
    if (gender === "male" || gender === "m") return 1;
    return "";
  };

  const calculateCustomerAge = (birthDay) => {
    const age = calculateAge(birthDay);
    return age.years > 0 && birthDay !== "0001-01-01" ? age.years : 0;
  };

  const isValidBirthDay = (birthDay) => {
    return birthDay !== "0001-01-01" && birthDay !== "0000-00-00";
  };

  const isValidReportType = (reportType) => {
    return reportType !== 0;
  };

  const isBirthPlaceIdRequired = (reportType) => {
    return reportType >= 1 && reportType <= 9;
  };

  const createPostParams = ({
    firstName,
    lastName,
    gender,
    email,
    birthDay,
    birthCountry,
    birthCity,
    birthPlaceId,
    customerAge,
    birthTime,
  }) => {
    const name = `${firstName} ${lastName}`;
    const [birthYear, birthMonth, birthDayNum] = birthDay.split("-");
    const [birthHour, birthMinute] = birthTime
      ? birthTime.split(":")
      : ["00", "00"];

    return {
      name,
      gender,
      email,
      birthday: birthDayNum,
      birthmonth: birthMonth,
      birthyear: birthYear,
      birthcountry: birthCountry,
      birthplace: birthCity,
      birthplaceid: birthPlaceId,
      reportage: customerAge,
      birthhour: birthHour,
      birthminute: birthMinute,
    };
  };

  const getReportData = (reportType) => {
    const reportConfig = {
      1: {
        apiEndpoint:
          "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php",
        type: 3,
        product: "personal",
        duration: "",
      },
      2: {
        apiEndpoint:
          "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php",
        type: 1,
        product: "year",
        duration: "",
      },
      3: {
        apiEndpoint:
          "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php",
        type: 7,
        product: "year-dig",
        duration: "12",
      },
      4: {
        apiEndpoint:
          "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php",
        type: 9,
        product: "year-eyf-report",
        duration: "",
      },
      5: {
        apiEndpoint:
          "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php",
        type: 11,
        product: "year-eyf-2016",
        duration: "",
      },
      6: {
        apiEndpoint:
          "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php",
        type: 10,
        product: "seasonal-eyf-2016",
        duration: "3",
      },
      7: {
        apiEndpoint:
          "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php",
        type: 10,
        product: "seasonal-eyf-2016",
        duration: "6",
      },
      8: {
        apiEndpoint:
          "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php",
        type: 10,
        product: "seasonal-eyf-2016",
        duration: "12",
      },
      9: {
        apiEndpoint:
          "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php",
        type: 12,
        product: "personal",
        duration: "12",
        format: "xml",
      },
      10: {
        apiEndpoint: `https://services.astrologyanswers.com/process/info/send_request_tpg_report_v2.php?email=${currentCustomer.user.email}&type=tpgcustom&period=3`,
      },
      11: {
        apiEndpoint: `https://services.astrologyanswers.com/process/info/send_request_tpg_report_v2.php?email=${currentCustomer.user.email}&type=tpgcustom&period=6`,
      },
      12: {
        apiEndpoint: `https://services.astrologyanswers.com/process/info/send_request_tpg_report_v2.php?email=${currentCustomer.user.email}&type=tpgcustom&period=12`,
      },
    };

    return reportConfig[reportType];
  };

  const createReportUrl = (reportData, postParams) => {
    const apiid = "61c6bb50b28ecca46021fa8ac07281c6";
    const language = "en";

    // Astrowow Reports
    if (
      reportData.apiEndpoint ===
      "https://n67709i556.execute-api.us-east-1.amazonaws.com/Prod/astrologyanswers.php"
    ) {
      const reportFormat = reportData.format ? `&format=${reportData.format}` : '';
      return `${reportData.apiEndpoint}?apiid=${apiid}&product=${
        reportData.product
      }&language=${language}&currency=1&delivery=email&${new URLSearchParams({
        ...postParams,
        reportduration: reportData.duration,
      })}${reportFormat}`;
    }

    return reportData.apiEndpoint;
  };

  const sendRequestBasedOnType = (reportUrl, type) => {
    if (type) {
      sendRequestWow(reportUrl, type);
    } else {
      sendRequest(reportUrl);
    }
  };
  const modalLoaded = () => {
    setReportSent(false);
    setButtonText("Generate");
    setShowSpinner("visually-hidden");
    setReportInput({ reportType: 0 });
  };

  return (
    <>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
        onEntered={modalLoaded}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="app-card app-card-orders-table mb-5">
            <div className="app-card-body">
              <div className="table-responsive">
                <table className="table table-condensed">
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td>
                        {currentCustomer.user.firstName}{" "}
                        {currentCustomer.user.lastName || ""}
                      </td>
                    </tr>
                    <tr>
                      <td>Date of Birth</td>
                      <td>
                        {currentCustomer.user.birthDay &&
                          new Date(
                            currentCustomer.user.birthDay
                          ).toLocaleDateString("en-US", {
                            month: "long",
                            day: "2-digit",
                            year: "numeric",
                            timeZone: "UTC",
                          })}
                      </td>
                    </tr>
                    <tr>
                      <td>Time of Birth</td>
                      <td>{currentCustomer.user.birthTime}</td>
                    </tr>
                    <tr>
                      <td>Star Sign</td>
                      <td>{getSign(currentCustomer.user.signId)}</td>
                    </tr>
                    <tr>
                      <td>Gender</td>
                      <td>{getGender(currentCustomer.user.gender)}</td>
                    </tr>
                    <tr>
                      <td>Birth Country</td>
                      <td>
                        {getCountryLabel(currentCustomer.user.birthCountry)}
                      </td>
                    </tr>
                    {currentCustomer.user.birthCountry === "United States" && (
                      <tr>
                        <td>Birth State</td>
                        <td>
                          {getStateLabel(currentCustomer.user.birthState)}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td>Birth City</td>
                      <td>{currentCustomer.user.birthCity}</td>
                    </tr>
                    <tr>
                      <td>Birth Place Id</td>
                      <td>{currentCustomer.user.birthPlaceId}</td>
                    </tr>
                    <tr>
                      <td>Report Type</td>
                      <td>
                        <select
                          name="reportType"
                          className="form-select"
                          onChange={(e) =>
                            setReportInput({
                              ...reportInput,
                              reportType: e.target.value,
                            })
                          }
                        >
                          <option value="0">Select Report Type</option>
                          {reportTypesList}
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <button
                          type="submit"
                          className="btn btn-info"
                          onClick={handleRequest}
                        >
                          <span
                            className={`spinner-grow spinner-grow-sm me-1 ${showSpinner}`}
                          ></span>
                          {buttonText}
                        </button>
                        {reportSent && (
                          <span className="mx-1 text-success">
                            Your request has been submitted. Please check back
                            in a minute or two for your report.
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClick}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
